import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  companyId: string
  name: string
  color: string
}

export function useCreateStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ companyId, name, color }: Props) => {
      const response = await axios.post('workflow-statuses', {
        company_id: companyId,
        name,
        color,
      })
      return response.data
    },
    onSuccess: ({ companyId }) => {
      queryClient.invalidateQueries(['workflow-statuses', companyId])
    },
  })
}
